import React, { useState, useEffect } from "react";
import { Container } from "../../components/Container/index";
import { Form, Input, Button, message } from "antd";
import { SizeBox } from "../../components/SizeBox/index";
import styles from "./styles.module.less";
import axios from "axios";
import { User } from "authing-js-sdk";
import { useNavigateWithSearch } from "../../hooks/useNavigateWithSearch";
import { useTitle } from "../../hooks/useTitle";
import { getImgSrc } from "../../utils";
import { useTranslation } from "react-i18next";

export const RegisterCompletePage = () => {
  const { t } = useTranslation();

  useTitle(t("common.registerInfoFill"));

  const [form] = Form.useForm();
  const navigate = useNavigateWithSearch();
  const [user, setUser] = useState<User | null>();
  const [definitions, setDefinitions] = useState<any[]>([]);
  const extendsFields = window.__config__.extendsFields;

  const onFinish = async (values: any) => {
    const internalFields: any = {};
    const userFields: any[] = [];
    Object.entries(values).forEach(([key, value]) => {
      const [type, nameOrId] = key.split(" ");
      if (type === "internal") {
        internalFields[nameOrId] = value;
      } else if (type === "user") {
        userFields.push({ nameOrId, value });
      }
    });

    const user = await window.__authing__.updateProfile(internalFields);
    setUser(user);
    await axios.post(
      `/api/v2/udfs/values`,
      {
        udfs: userFields.map(({ nameOrId, value }) => ({
          definition: definitions.find((def) => def.id === nameOrId),
          value,
        })),
      },
      {
        headers: {
          authorization: user?.token,
        },
      }
    );
    message.success(t("common.operateSuccess"));

    setTimeout(() => navigate("/login"), 500);
  };

  useEffect(() => {
    (async () => {
      const user = await window.__authing__.getCurrentUser();
      setUser(user);
      const { data: definitions } = await axios.get("/api/v2/udfs/definitions", {
        headers: {
          authorization: user?.token,
        },
      });
      setDefinitions(definitions);
    })();
  }, []);

  const items = extendsFields.map((def) => {
    const key = `${def.type} ${def.type === "internal" ? def.name : def.id}`;
    return user && (user as any)[def.name] && def.type === "internal" ? (
      <Form.Item key={key} label={def.label} style={{ marginBottom: 8 }}>
        <Input type="text" value={(user as any)[def.name]} readOnly size="large" />
      </Form.Item>
    ) : (
      <Form.Item key={key} name={key} label={def.label} style={{ marginBottom: 8 }}>
        <Input type={def.inputType} size="large" />
      </Form.Item>
    );
  });

  return (
    <Container minHeight="auto">
      <h1 className={styles.title}>{t("common.perfectUserInfo")}</h1>

      <div className={styles.subTitle} style={{ height: 100 }}>
        <p>
          {t("common.welcomeJoinAndPerfect", {
            name: window.__config__.name,
          })}
        </p>
        <img src={getImgSrc("/20200904122043.svg")} alt="" />
      </div>

      <Form form={form} layout="vertical" onFinish={onFinish}>
        {items}

        <SizeBox height={20} />
        <Form.Item>
          <Button block size="large" type="primary" htmlType="submit">
            {t("common.submit")}
          </Button>
        </Form.Item>
      </Form>
    </Container>
  );
};
